import AppLoader from "../../Components/Loader/AppLoader";
import PrivateRoute from "./PrivateRoute";

import { Suspense, lazy } from "react";
import { useTranslation } from "react-i18next";
import { GetStorage, RemoveStorage } from "../../Utils/Storage";
import { Route, Switch, Redirect } from "react-router-dom";

import "../../i18n";

const Login = lazy(() => import("../../Pages/Login"));
const MapView = lazy(() => import("../../Pages/Map"));
const Ticket = lazy(() => import("../../Pages/Ticket"));
const Planning = lazy(() => import("../../Pages/Planning"));
const MicroHubs = lazy(() => import("../../Pages/MicroHubs"));
const DriverLog = lazy(() => import("../../Pages/DriverLog"));
const Analytics = lazy(() => import("../../Pages/Analytics"));
const NotFound = lazy(() => import("../../Pages/PageNotFound"));
const LogHistory = lazy(() => import("../../Pages/LogHistory"));
const SearchOrder = lazy(() => import("../../Pages/SearchOrder"));
const Tenant = lazy(() => import("../../SuperAdmin/Pages/Tenant"));
const LoginAdmin = lazy(() => import("../../SuperAdmin/Pages/Login"));
const LoginByKey = lazy(() => import("../../Pages/Login/LoginByKey"));
const DriverManagement = lazy(() => import("../../Pages/DriverManagment"));
const Organization = lazy(() => import("../../SuperAdmin/Pages/Organization"));
const UsageDashboard = lazy(() =>
  import("../../Pages/Analytics/UsageDashboard")
);
const Organizations = lazy(() =>
  import("../../SuperAdmin/Pages/Organizations")
);
const ORG_Tenant = lazy(() =>
  import("../../OrganizationDashboard/Pages/Tenant")
);
const LoginOrgAdmin = lazy(() =>
  import("../../OrganizationAdminDashborad/Pages/Login")
);
const LoginOrganizationManager = lazy(() =>
  import("../../OrganizationDashboard/Pages/Login")
);
const AdminOrganization = lazy(() =>
  import("../../OrganizationAdminDashborad/Pages/Organization")
);
const OrganizaiotnManagerTenant = lazy(() =>
  import("../../OrganizationAdminDashborad/Pages/Tenant")
);
const AdminOrganizations = lazy(() =>
  import("../../OrganizationAdminDashborad/Pages/Organizations")
);
const OrganizationManager = lazy(() =>
  import("../../OrganizationDashboard/Pages/OrganizationManager")
);
const OrganizationAdmin = lazy(() =>
  import("../../OrganizationAdminDashborad/Pages/OrganizationAdmin")
);

const OptimeRouter = () => {
  const { t } = useTranslation();

  let token =
    GetStorage("check_user_tenant_token") || GetStorage("optime_token");

  return (
    <Suspense fallback={<AppLoader message={t("LoadingPage")} />}>
      <Switch>
        <Route
          exact
          path="/"
          render={() =>
            token ? <Redirect to="/planning" /> : <Redirect to="/login" />
          }
        />
        <Route
          path="/login"
          exact
          // component={(props) =>
          //   token ? <Redirect to="/planning" /> : <Login {...props} />
          // }
          render={(props) =>
            token ? <Redirect to="/planning" /> : <Login {...props} />
          }
        />

        <Route
          path="/login/:userLoginKey"
          component={(props) =>
            token ? <Redirect to="/planning" /> : <LoginByKey {...props} />
          }
        />

        <Route
          exact
          path="/optime-admin/couper-atmin"
          render={() => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <Redirect to="/optime-admin/couper-atmin/organization" />
            ) : (
              <Redirect to="/optime-admin/couper-atmin/login" />
            );
          }}
        />

        <Route
          path="/optime-admin/couper-atmin/login"
          // component={(props) => {
          //   token = GetStorage("optime_token");
          //   RemoveStorage("check_user_tenant_token");
          //   return token ? (
          //     <Redirect to="/optime-admin/couper-atmin/organization" />
          //   ) : (
          //     <LoginAdmin {...props} />
          //   );
          // }}
          render={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <Redirect to="/optime-admin/couper-atmin/organization" />
            ) : (
              <LoginAdmin {...props} />
            );
          }}
        />

        <Route
          path="/optime-admin/organization-admin/login"
          component={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return <LoginOrgAdmin {...props} />;
          }}
        />

        <Route
          path="/optime-admin/organization-admin/login"
          // component={(props) => {
          //   token = GetStorage("optime_token");
          //   RemoveStorage("check_user_tenant_token");
          //   return token ? (
          //     <Redirect to="/organization-manager" />
          //   ) : (
          //     <LoginOrganizationManager {...props} />
          //   );
          // }}
          render={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <Redirect to="/organization-manager" />
            ) : (
              <LoginOrganizationManager {...props} />
            );
          }}
        />

        <Route
          exact
          path="/optime-admin/organization-admin/:adminId"
          component={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <OrganizationAdmin {...props} />
            ) : (
              <Redirect to="/optime-admin/organization-admin/login" />
            );
          }}
        />

        <Route
          exact
          path="/organization-manager"
          component={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <OrganizationManager {...props} />
            ) : (
              <Redirect to="/organization-manager/login" />
            );
          }}
        />

        <Route
          path="/organization-manager/login"
          // component={(props) => {
          //   token = GetStorage("optime_token");
          //   RemoveStorage("check_user_tenant_token");
          //   return token ? (
          //     <Redirect to="/organization-manager" />
          //   ) : (
          //     <LoginOrganizationManager {...props} />
          //   );
          // }}
          render={(props) => {
            token = GetStorage("optime_token");
            RemoveStorage("check_user_tenant_token");
            return token ? (
              <Redirect to="/organization-manager" />
            ) : (
              <LoginOrganizationManager {...props} />
            );
          }}
        />

        <PrivateRoute
          admin={true}
          path="/organization-manager/tenant/:id/:orgId"
          component={ORG_Tenant}
        />

        <PrivateRoute
          orgAdmin={true}
          path="/optime-admin/organization-admin/tenant/:id/:orgId"
          component={OrganizaiotnManagerTenant}
        />

        <PrivateRoute
          admin={true}
          exact={true}
          path="/optime-admin/couper-atmin/organization/:id"
          component={Organization}
        />

        <PrivateRoute
          orgAdmin={true}
          exact={true}
          path="/optime-admin/organization-admin/organization/:id"
          component={AdminOrganization}
        />

        <PrivateRoute
          admin={true}
          path="/optime-admin/couper-atmin/organization"
          component={Organizations}
        />

        <PrivateRoute
          orgAdmin={true}
          path="/optime-admin/organization-admin/organization"
          component={AdminOrganizations}
        />

        <PrivateRoute
          admin={true}
          path="/optime-admin/couper-atmin/tenant/:id/:orgId"
          component={Tenant}
        />

        <PrivateRoute path="/ticket" component={Ticket} />

        <PrivateRoute path="/planning" component={Planning} />

        <PrivateRoute path="/search-order" component={SearchOrder} />

        <PrivateRoute path="/log/:planId/:planName" component={LogHistory} />

        <PrivateRoute path="/microhub" component={MicroHubs} />

        <PrivateRoute
          path="/map/:viewState/:vehicle/:planId/:admin?"
          component={MapView}
        />

        <PrivateRoute path="/driver-management" component={DriverManagement} />

        <PrivateRoute path="/driver-log" component={DriverLog} />

        <PrivateRoute path="/analytics" exact={true} component={Analytics} />
        <PrivateRoute
          path="/analytics/usage"
          exact={true}
          component={UsageDashboard}
        />

        <Route path="*" component={NotFound} />
      </Switch>
    </Suspense>
  );
};

export { OptimeRouter };
